import { notNullish } from '@paragon/utilities';

export function findNextName(otherNames: readonly string[], options: { prefix?: string } = {}): string {
  const regex = options.prefix ? new RegExp(`^${options.prefix}-(\\d+)$`, 'i') : /^(\d+)$/;
  const otherNumbers = otherNames
    .map((name) => name.match(regex)?.[1])
    .filter(notNullish)
    .map((n) => parseInt(n, 10));

  const nextNumber = otherNumbers.length === 0 ? 1 : Math.max(...otherNumbers) + 1;

  return options.prefix ? `${options.prefix}-${nextNumber}` : nextNumber.toString();
}
